import TextField from '@mui/material/TextField';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {StaticDatePicker} from '@mui/x-date-pickers/StaticDatePicker';
import React, {useContext, useState} from "react";
import {Box, Chip, Grid, useTheme} from "@mui/material";
import {encode} from 'js-base64';
import Typography from "@mui/material/Typography";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {hu} from "date-fns/locale";
import {formatHuman} from "../../utils/dateUtils";
import ReservationContext from "../../context/ReservationContext";
import useReservationQueries from "../../hooks/queries/useReservationQueries";


const Slot = ({time, ...rest}) => {
    const theme = useTheme()
    return <Chip
        {...rest}
        label={time.start + '-' + time.end}
        style={{
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.primary['20'],
            fontWeight: '600',
        }}/>
}

const NoAvailableTime = () => <Box sx={{width: '100%', justifyContent: 'center', alignItems: 'center', alignSelf: 'center'}}>
    <Typography variant="subtitle1" align="center">Erre a napra nincsenek szabad időpontok!</Typography>
    <Typography variant="body2" gutterBottom align="center">Válassz másik időpontot!</Typography>
</Box>


const AvailableTime = ({slots, proceed, selectedDate}) => {
    return <>
        <Typography variant="subtitle2" align="center">Szabad időpontok - {formatHuman(selectedDate)}</Typography>
        <Typography variant="body2" gutterBottom align="center">Válassz szabad időpontot az alábbiak közül!</Typography>
        <Grid container spacing={1}>
            {slots?.map((s, i) => <Grid style={{display: 'flex', justifyContent: 'center'}} item xs={4} xl={4} key={`slot_${i}`}>
                <Slot time={s} onClick={() => proceed(s)}/>
            </Grid>)}
        </Grid>
    </>
}


const SelectDate = () => {
    const today = new Date()
    const {next, selected} = useContext(ReservationContext)
    const [selectedDate, setSelectedDate] = useState(new Date())
    const [month, setMonth] = useState(today.getMonth() + 1)
    const [year, setYear] = useState(today.getFullYear())

    const {useFreeSlotsForDate, useMonthlyAvailability} = useReservationQueries()

    const {data: slots, } = useFreeSlotsForDate(selected?.price?.id, formatHuman(selectedDate))
    const {data: availability} = useMonthlyAvailability(selected?.price?.id, year, month)

    const toUriSafe = (s) => {
        let encoded = encode(formatHuman(selectedDate) + '|' + s.start + '|' + s.end);
        return encoded.replace('==', '');
    }

    const isAvailableForReserve = (date) => {
        if (availability === undefined) return false
        if (Object.keys(availability).includes(formatHuman(date))) return !availability[formatHuman(date)]
        return false
    }

    const proceed = (d) => next({...selected, date: toUriSafe(d)})

    const monthChange = (d) => {
        const selectedMonth = d.getMonth() + 1
        const selectedYear = d.getFullYear()
        setMonth(selectedMonth)
        setYear(selectedYear)
    }

    return <div className="data-container">
        <div className="date-select-container">
            <div className="date-select-calendar">
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={hu}>
                    <StaticDatePicker
                        displayStaticWrapperAs="desktop"
                        disablePast
                        openTo="day"
                        shouldDisableDate={isAvailableForReserve}
                        value={selectedDate}
                        onChange={(newValue) => setSelectedDate(newValue)}
                        onMonthChange={(d) => monthChange(d)}
                        onYearChange={(d) => monthChange(d)}
                        renderInput={(params) => <TextField {...params} />}
                    />
                </LocalizationProvider>
            </div>
            <div className="data-container-slots" style={slots?.length !== 0 ? {} : {display: 'flex'}}>
                {slots?.length !== 0 ? <AvailableTime slots={slots} proceed={proceed} selectedDate={selectedDate}/>: <NoAvailableTime/>}
            </div>
        </div>

    </div>
}

export default SelectDate